import React from 'react';
import styled from '@emotion/styled';
import { mq } from 'style/variables';
import sizes from 'style/sizes';
import colors from 'style/colors';
import { text } from 'style/mixin';
import fonts from 'style/fonts';
import { Arrow } from 'components/atoms/arrow';

type ContactProps = {
  address: string;
  margin?: boolean;
};

const Container = styled.div<ContactProps>`
  margin-top: ${props => (props.margin ? '64px' : '')};
  display: flex;
  align-items: center;
  ${mq.onlysp} {
    margin-top: ${props => (props.margin ? '49px' : '')};
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ContactHeadline = styled.p`
  display: flex;
  ${text(12, 22 / 12, true)};
  letter-spacing: 0.05em;
  ${mq.onlysp} {
    margin-bottom: 9px;
  }
  span {
    font-family: ${fonts.enGothic};
  }
  &::after {
    color: ${colors.black01};
    content: ':';
    display: inline-block;
    margin-left: 11px;
    margin-right: ${sizes.margin[17]};
    ${mq.onlysp} {
      margin: 0 15px;
    }
  }
`;

const ContactLink = styled.a`
  display: flex;
  align-items: center;
`;

const ContactArrow = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: 8px;
`;

export const Contact: React.FC<ContactProps> = props => {
  const type = props.address && props.address.indexOf('@') > 0 ? 'mail' : 'link';

  return (
    <Container {...props}>
      <ContactHeadline>
        <span>CONTACT</span>
      </ContactHeadline>
      <ContactLink
        href={type === 'mail' ? `mailto:${props.address}` : props.address}
        {...(type === 'link'
          ? {
              target: '_blank',
              rel: 'noopener noreferrer',
            }
          : {})}
      >
        <div>{props.address}</div>
        <ContactArrow>
          <Arrow color="black" />
        </ContactArrow>
      </ContactLink>
    </Container>
  );
};
